import { ApplicantsApplicantIdReportGetPresetEnum } from 'src/lib/internal/epa/gen';

export { ApplicantsApplicantIdReportGetPresetEnum as ApplicantReportPreset };

export enum ApplicantSubmissionDocumentSources {
  BANK_LINKING = 'BANK_LINKING',
  CONNECTED_PAYROLL = 'CONNECTED_PAYROLL',
  TAX_RETURN_LINKING = 'TAX_RETURN_LINKING'
}
